import { Box } from "@chakra-ui/react";
import type { MenuExtendedProps } from "config/menus/menus.d";
import { MenuLinkWithSubmenu } from "./MenuLinkWithSubmenu";
import { TopMenuLink } from "./TopMenuLink";

export const MenuItemsExperiment = ({ menu }: { menu: Array<MenuExtendedProps> }) => {
  const menuLinksMapped = (
    <>
      {menu.map((item: MenuExtendedProps) => {
        const { subMenu, label } = item;
        const menuLink = <TopMenuLink menuItem={item} />;

        return (
          <Box key={label} pb={{ base: 5, lg: 0 }}>
            {subMenu ? <MenuLinkWithSubmenu menuLink={menuLink} submenu={subMenu} /> : menuLink}
          </Box>
        );
      })}
    </>
  );

  return menuLinksMapped;
};
